module.exports = __webpack_public_path__ + "img/icon-heat.75272e94.svg";